// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_1HviP","tableView":"_3N5rz","tableHeaderStrip":"gji9a"};